module.exports = __webpack_public_path__ + "static/media/github-logo.fe1b614f.svg";